import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_TRANSPORT_REFERENCE_DATA_URL } from '../../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getTransportReferenceData = createAsyncThunk(
  'stop/getTransportReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(EPISODE_TRANSPORT_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const transportReferenceSlice = createSlice({
  name: 'stop/transportReferenceSlice',
  initialState: null,
  reducers: {
    resetTransportReference: () => null,
  },
  extraReducers: {
    [getTransportReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetTransportReference } = transportReferenceSlice.actions;

export default transportReferenceSlice.reducer;
